var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80438 0.668431C9.68122 0.559352 9.51458 0.501604 9.3407 0.501604C9.16682 0.501604 9.00018 0.559352 8.87702 0.668431L5.00091 4.11405L1.11031 0.668431C0.856729 0.443856 0.44376 0.443856 0.190183 0.668431C-0.0633943 0.893006 -0.0633943 1.25874 0.190183 1.48332L4.53722 5.33317C4.66039 5.44225 4.82702 5.5 5.00091 5.5C5.17479 5.5 5.34142 5.44225 5.46459 5.33317L9.81163 1.48332C9.93479 1.37424 10 1.22666 10 1.07267C10 0.925088 9.92755 0.77751 9.80438 0.668431Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.7b5126a9858fbb28ace085fef0a99bf8.svg";
export { ForwardRef as ReactComponent };